import LoginPage from "./login-page/LoginPage";
export {
    LoginPage
}